var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 0.66333C1.33789 0.66333 0.75 1.25122 0.75 1.97583V10.7258C0.75 11.4504 1.33789 12.0383 2.0625 12.0383H2.5C2.5 13.4875 3.67578 14.6633 5.125 14.6633C6.57422 14.6633 7.75 13.4875 7.75 12.0383H11.25C11.25 13.4875 12.4258 14.6633 13.875 14.6633C15.3242 14.6633 16.5 13.4875 16.5 12.0383H17.375C17.859 12.0383 18.25 11.6473 18.25 11.1633C18.25 10.6793 17.859 10.2883 17.375 10.2883V8.53833V7.66333V7.152C17.375 6.68716 17.1918 6.24146 16.8637 5.91333L14.75 3.79966C14.4219 3.47153 13.9762 3.28833 13.5113 3.28833H12.125V1.97583C12.125 1.25122 11.5371 0.66333 10.8125 0.66333H2.0625ZM12.125 5.03833H13.5113L15.625 7.152V7.66333H12.125V5.03833ZM3.8125 12.0383C3.8125 11.6902 3.95078 11.3564 4.19692 11.1103C4.44306 10.8641 4.7769 10.7258 5.125 10.7258C5.4731 10.7258 5.80694 10.8641 6.05308 11.1103C6.29922 11.3564 6.4375 11.6902 6.4375 12.0383C6.4375 12.3864 6.29922 12.7203 6.05308 12.9664C5.80694 13.2125 5.4731 13.3508 5.125 13.3508C4.7769 13.3508 4.44306 13.2125 4.19692 12.9664C3.95078 12.7203 3.8125 12.3864 3.8125 12.0383ZM13.875 10.7258C14.2231 10.7258 14.5569 10.8641 14.8031 11.1103C15.0492 11.3564 15.1875 11.6902 15.1875 12.0383C15.1875 12.3864 15.0492 12.7203 14.8031 12.9664C14.5569 13.2125 14.2231 13.3508 13.875 13.3508C13.5269 13.3508 13.1931 13.2125 12.9469 12.9664C12.7008 12.7203 12.5625 12.3864 12.5625 12.0383C12.5625 11.6902 12.7008 11.3564 12.9469 11.1103C13.1931 10.8641 13.5269 10.7258 13.875 10.7258Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 14,
    fill: "white",
    transform: "translate(0.75 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSolid);
export default __webpack_public_path__ + "static/media/truck-solid.5b1be1f4f02399558d7fd5a7e32184c6.svg";
export { ForwardRef as ReactComponent };